export const CONCRETE_BASE_MODULE_NAME = "concrete-base";
